// gameSoundButton.js
var GameSoundButton = pc.createScript('gameSoundButton');

// initialize code called once per entity
GameSoundButton.prototype.initialize = function() {

    let muteOn = this.app.assets.findByTag("Btn_SoundOffTag");
    let muteOff = this.app.assets.findByTag("Btn_SoundOnTag");

    if (PlayerManager.instance.userData.gameSound == true) {
        this.entity.element.texture = muteOff[0].resource;
    }
    else {
        this.entity.element.texture = muteOn[0].resource;
    }
    this.entity.button.on("click", function(){
        
        if (PlayerManager.instance.userData.gameSound == true){
            PlayerManager.instance.userData.gameSound = false;
            this.entity.element.texture = muteOn[0].resource;
        }
        else {
            PlayerManager.instance.userData.gameSound = true;
            this.entity.element.texture = muteOff[0].resource;
        }
        PlayerManager.instance.SavePlayerData();
    }, this);
};


